/**
 * parseControl — parsing déterministe des mots de contrôle vocaux (US-VDPI-03 AC2).
 *
 * Plan §5 — mots de contrôle reconnus :
 *   - "validation"  → { kind: 'validate' }
 *   - "corrige"     → { kind: 'correct' }
 *   - "annule"      → { kind: 'cancel' }
 *
 * La sélection (patient / action) se fait 100 % par NUMÉRO (pivot E4) via
 * `parseNumber`, jamais par lettre. Pur, sans dépendance DOM : testable en isolation.
 */

export type ControlCommand =
  | { kind: 'validate' }
  | { kind: 'correct' }
  | { kind: 'cancel' }
  | { kind: 'none' };

/** Synonymes tolérés pour robustesse ASR français. */
const VALIDATE_WORDS = ['validation', 'valider', 'valide', 'confirme', 'confirmer', 'confirmation'];
const CORRECT_WORDS = ['corrige', 'corriger', 'correction'];
const CANCEL_WORDS = ['annule', 'annuler', 'annulation'];

/** Normalise : minuscules, sans accents, ponctuation → espaces. */
function normalize(text: string): string {
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^\w\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function parseControl(transcript: string): ControlCommand {
  const norm = normalize(transcript);
  if (!norm) return { kind: 'none' };

  const tokens = norm.split(' ');

  if (tokens.some((t) => CANCEL_WORDS.includes(t))) return { kind: 'cancel' };
  if (tokens.some((t) => CORRECT_WORDS.includes(t))) return { kind: 'correct' };
  if (tokens.some((t) => VALIDATE_WORDS.includes(t))) return { kind: 'validate' };

  return { kind: 'none' };
}
